/**
 * Routes /app/settings: installer settings when fleet mode, else redirect to property settings.
 */

import { Navigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import InstallerSettings from './InstallerSettings';
import SettingsPage from './Settings';

export default function SettingsRouter() {
  const { isInstaller, selectedPropertyId, properties, navigationScope } = useApp();

  // Installer scoped to a property → show that property's settings
  if (isInstaller && navigationScope.type === 'property' && navigationScope.propertyId) {
    return <Navigate to={`/app/property/${navigationScope.propertyId}/settings`} replace />;
  }

  if (isInstaller) {
    return <InstallerSettings />;
  }

  if (selectedPropertyId) {
    return <Navigate to={`/app/property/${selectedPropertyId}/settings`} replace />;
  }

  if (properties.length > 0) {
    return <Navigate to={`/app/property/${properties[0].id}/settings`} replace />;
  }

  return <SettingsPage />;
}
